import { createAction } from 'redux-starter-kit';

export const SET_IMPORTING_POLICIES = 'SET/importing-policies';

const setIsImportingPolicies = createAction(SET_IMPORTING_POLICIES);

export const PolicyImportActions = {
  setIsImportingPolicies
};
